export default [
    //信息漏斗表
    {
        path: '/loudnew/LoudMain',
        name: '/loudnew/LoudMain',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/loudnew/LoudMain.vue'),
        meta: {
            title: '信息漏斗',
            isTabsPage: true,
            keepAlive:true
        }
    },

    //信息漏斗表
    {
        path: '/loudnew/newLoudMainDetails',
        name: '/loudnew/newLoudMainDetails',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/loudnew/newLoudMainDetails.vue'),
        meta: {
            title: '信息漏斗详情',
            isTabsPage: true,
            keepAlive:true
        }
    },
    //信息漏斗非签约商审批
    {
        path: '/loudnew/loudMainDetailsAddShenpi',
        name: '/loudnew/loudMainDetailsAddShenpi',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/loudnew/loudMainDetailsAddShenpi.vue'),
        meta: {
            title: '信息漏斗非签约商审批',
            isTabsPage: true,
            keepAlive:true
        }
    },

    //信息漏斗表
    {
        path: '/loudnew/LoudMainFQianYue',
        name: '/loudnew/LoudMainFQianYue',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/loudnew/LoudMainFQianYue.vue'),
        meta: {
            title: '非签约用户信息漏斗',
            isTabsPage: true,
            keepAlive:true
        }
    },


]
